

import type { IChildProp } from '@intelligence/components/Form/type';
import moment, { Moment } from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TYPE = 'date';
export const DATE_TYPES = [DATE_TYPE];

export const DEFAULT_DATE_SHORTCUT = {
  name: 'Last 7 Days',
  nameCN: '最近7天',
  onClick: () =>
    [moment().subtract(7, 'day'), moment().subtract(1, 'day')] as [
      Moment,
      Moment,
    ],
};

export const MINI_GAME_DETAIL_METRICS = ['game_count'] as const;

export const MINI_GAME_DETAIL_DIMENSIONS = [
  {
    key: 'wechat_popularity',
    platform: 'wechat',
    label: 'dbi_top_rank_wechat_popularity',
  },
  {
    key: 'wechat_bestseller',
    platform: 'wechat',
    label: 'dbi_top_rank_wechat_bestseller',
  },
  {
    key: 'wechat_most_played',
    platform: 'wechat',
    label: 'dbi_top_rank_wechat_most_played',
  },
  {
    key: 'douyin_popularity',
    platform: 'douyin',
    label: 'dbi_top_rank_douyin_popularity',
  },
  {
    key: 'douyin_bestseller',
    platform: 'douyin',
    label: 'dbi_top_rank_douyin_bestseller',
  },
  {
    key: 'douyin_fresh_game',
    platform: 'douyin',
    label: 'dbi_top_rank_douyin_fresh_game',
  },
] as const;

export const DEFAULT_MINIGAME_TYPES: string[] = MINI_GAME_DETAIL_DIMENSIONS.map(d => d.key);

export const MINI_GAME_CASCADE_OPTIONS: IChildProp[] = [
  {
    value: 'wechat',
    labelKey: 'dbi_platform_wechat',
    icon: 'weixin',
    hideChildrenCount: true,
    children: MINI_GAME_DETAIL_DIMENSIONS.filter(d => d.platform === 'wechat').map(d => ({
      value: d.key,
      labelKey: d.label,
    })),
  },
  {
    value: 'douyin',
    labelKey: 'dbi_platform_douyin',
    icon: 'douyin',
    hideChildrenCount: true,
    children: MINI_GAME_DETAIL_DIMENSIONS.filter(d => d.platform === 'douyin').map(d => ({
      value: d.key,
      labelKey: d.label,
    })),
  },
];

export const MINI_GAME_EXPORT_CONFIG = {
  businessType: 'minigame-details-store-rank',
  downloadKey: 'minigameDetailsStoreRank',
} as const;

export const getMiniGameDimensionLabelKey = (dimension: string): string => {
  const item = MINI_GAME_DETAIL_DIMENSIONS.find(
    entry => entry.key === dimension,
  );
  return item?.label || dimension;
};

export const getMiniGameDimensionPlatform = (dimension: string): string => {
  const item = MINI_GAME_DETAIL_DIMENSIONS.find(
    entry => entry.key === dimension,
  );
  return item?.platform || '';
};
